import { memo } from "react";
import FormTextField from "../FormTextField";

interface POIItemDetaiVideoProps {
    name: string;
}

function POIItemDetaiVideo({ name }: POIItemDetaiVideoProps) {
    return (
        <div>
            <FormTextField
                sx={{ mt: 1 }}
                fullWidth
                label="URL"
                variant="outlined"
                name={`${name}.url`}
            />
        </div>
    );
}

export default memo(POIItemDetaiVideo);
